<template>
	<icomoon class="pxrwwfgv-icon" :iconSet="iconSet" v-bind="$props" />
</template>

<script>
	import { Icomoon } from "vue-icomoon";
	import iconSet from "@/assets/fonts/WWFGatveder/selection.json";

	export default {
		components: { Icomoon },
		setup() {
			return {
				iconSet,
			};
		},
	};
</script>